<template>
  <div
    v-if="currencySettings.wantsFewerPackages"
    class="fewer-packages my-6 flex flex-col rounded-md bg-[--color-green-light] p-4 leading-6"
  >
    <div class="flex items-center gap-[10px]">
      <p class="text-md font-bold">{{ $t("shared.checkout.packages") }}</p>
      <VcIcon name="leaf" class="text-[--color-alert-d0]" :size="20"></VcIcon>
      <VcTooltip placement="right" hover width="max-content" flip-options="{ fallbackPlacements: ['top', 'bottom'] }">
        <template #trigger>
          <VcIcon name="information-circle" class="" :size="18"></VcIcon>
        </template>
        <template #title>{{ $t("shared.checkout.packages") }}</template>
        <template #content>
          <div class="flex flex-col gap-3">
            <div v-html-safe="$t('shared.checkout.packages_text_tooltip')"></div>
            <p v-html-safe="$t('shared.checkout.packages_text_tooltip1')"></p>
            <p v-html-safe="tooltipContactInfo"></p>
          </div>
        </template>
      </VcTooltip>
    </div>
    <div class="bg mt-4 flex flex-col gap-3">
      <VcCheckbox
        id="packages"
        v-model="wantsFewerPackages"
        :value="wantsFewerPackages"
        name="shippingSelection"
        :label="$t('shared.checkout.packages_label')"
        class="text-base font-medium"
      >
        {{ $t("shared.checkout.packages_label") }}
      </VcCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useFooterBlock } from "@/core/composables";
import { Logger } from "@/core/utilities";
import type { CurrencySettingsType } from "../../types";

interface IProps {
  currencySettings: CurrencySettingsType;
  wantsFewerPackages: boolean;
}

const emit = defineEmits<{
  "update:wantsFewerPackages": [value: boolean];
}>();

const props = defineProps<IProps>();

const { t } = useI18n();
const { footerBlock } = useFooterBlock();

const wantsFewerPackages = computed({
  get: () => props.wantsFewerPackages,
  set: (value: boolean) => emit("update:wantsFewerPackages", value),
});

const tooltipContactInfo = computed<string>(() => {
  Logger.debug("Rendering tooltip contact info");
  return t("shared.checkout.packages_text_tooltip2", [
    `<a class="text-[--link-color]" href="mailto:${footerBlock.value?.salesEmail}" data-gtm-lead-source="ShippingTooltipContactUsSalesMail">${footerBlock.value?.salesEmail}</a>`,
    `<a class="text-[--link-color]" href="tel:${footerBlock.value?.salesPhone}" data-gtm-lead-source="ShippingTooltipContactUsSalesPhone">${footerBlock.value?.salesPhone}</a>`,
  ]);
});
</script>
